export class CheckUser {
    email: string;
}